import { FC } from 'react';
import styled from 'styled-components';

const PageElement = styled.div<IProps>`
  grid-area: page;
  padding: ${({ padding }) => (padding || padding === 0 ? padding : '40')}px;
  background-color: ${({ theme, variation }) =>
    variation === 'primary' ? theme.vars.newColor.lightGS2 : 'transparent'};
  overflow: auto;
`;

export type PageVariation = 'normal' | 'primary';

export interface IProps extends IntrinsicProps {
  variation?: PageVariation;
  padding?: number;
  heading?: string;
}

export const Page: FC<IProps> = ({ padding, variation, children, ...props }) => (
  <PageElement padding={padding} variation={variation} data-testid="Page" {...props}>
    {children}
  </PageElement>
);
